import Swiper, { Grid, Keyboard, Lazy, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/grid';

class SliderGrid {
  el;
  instance = null;
  options = {
    modules: [ Grid, Keyboard, Lazy, Navigation ],
    navigation: {
      prevEl: '[data-slider-prev]',
      nextEl: '[data-slider-next]',
      disabledClass: 'slider__button--disabled',
      hiddenClass: 'slider__button--hidden',
      lockClass: 'slider__button--lock',
    },
    keyboard: true,
    lazy: {
      enabled: true,
      loadOnTransitionStart: true,
      loadPrevNext: true,
    },
    preloadImages: false,
    watchSlidesProgress: true,
    threshold: 5,
  };
  mainSlideEl;
  swiperEl;

  constructor(el, options) {
    this.el = el;
    this.options = {
      ...options,
      ...this.options,
    };
    this.mainSlideEl = this.el.querySelector('[data-ref="slider-grid-main-slide"]');
    this.swiperEl = this.el.querySelector('[data-ref="slider-grid-swiper"]');
    this.instantiate(this.swiperEl, this.options);
  }

  instantiate(swiperEl, options) {
    this.instance = new Swiper(swiperEl, {
      ...options,
      on: {
        progress: (swiper, progress) => {
          if (!this.mainSlideEl) return;
          this.setMainSlidePosition(swiper, progress);
        },
        setTransition: (swiper, transition) => {
          if (!this.mainSlideEl) return;
          this.mainSlideEl.style.transitionDuration = `${transition}ms`;
        },
      },
    });
  }

  setMainSlidePosition(swiper, progress) {
    if (window.innerWidth < 960) {
      this.mainSlideEl.style.transform = 'none';
    } else {
      this.mainSlideEl.style.transform = `translateX(${(swiper.wrapperEl.clientWidth - swiper.width - swiper.params.spaceBetween) * progress * -1}px)`;
    }
  }
}

export default SliderGrid;
